import { get as r, set as i } from "react-hook-form";

var e = function e(i, _e, t) {
  if (i && "reportValidity" in i) {
    var f = r(t, _e);
    i.setCustomValidity(f && f.message || ""), i.reportValidity();
  }
},
    t = function t(r, i) {
  var t = function t(_t) {
    var f = i.fields[_t];
    f && f.ref && "reportValidity" in f.ref ? e(f.ref, _t, r) : f.refs && f.refs.forEach(function (i) {
      return e(i, _t, r);
    });
  };

  for (var f in i.fields) t(f);
},
    f = function f(e, _f) {
  _f.shouldUseNativeValidation && t(e, _f);
  var o = {};

  for (var a in e) {
    var n = r(_f.fields, a);
    i(o, a, Object.assign(e[a], {
      ref: n && n.ref
    }));
  }

  return o;
};

export { f as toNestError, t as validateFieldsNatively };